<script>
	const { assetUrl } = require('utilities/urlUtilities');
	/**
	 * We arrive to this page from various contexts.
	 * If q.previewView, then we are in the context of the product's preview view.
	 * TODO add more documentation here
	 */

	const TYPE_MULTIPLE_CHOICE = 0;
	const TYPE_WRITTEN_ANSWER = 1;
	const TYPE_CLICK_TOUCH_WORD = 2;
	const TYPE_WHO_WHAT = 3;
	const TYPE_EXTERNAL_ACTIVITY = 4;
	const TYPE_IMAGE_ANSWER = 5;
	const TYPE_VOCAB_MULTIPLE_CHOICE = 6;
	const TYPE_SPOKEN = 7;
	const TYPE_TRUE_FALSE = 8;

	// see /article/0022d641-ed88-4b92-8fbf-fe6e07975da8 types 0, 1, 2, 3, 5
	// see /article/19e63760-e15e-4f6d-a4fb-e3591211acf5 types 0, 1 & 4
	// see /article/3c39ae81-420d-465b-b98e-299b5ce08311  types 0, 1 & 3
	// see /article/95dea589-45f4-4604-b52b-6d9358fa9197 types 0 & 1

	module.exports = {
		props: ['q', 'submitted-answer', 'index', 'product', 'qsid', 'showTts'],
		components: {
			'text-to-speech-player-simple': require('components/text-to-speech-player-simple.vue').default,
			'question-text': require('components/question-text.vue').default
		},
		data: function () {
			return {
				TYPE_MULTIPLE_CHOICE,
				TYPE_WRITTEN_ANSWER,
				TYPE_CLICK_TOUCH_WORD,
				TYPE_WHO_WHAT,
				TYPE_EXTERNAL_ACTIVITY,
				TYPE_IMAGE_ANSWER,
				TYPE_VOCAB_MULTIPLE_CHOICE,
				TYPE_SPOKEN,
				TYPE_TRUE_FALSE,
				scoreClasses: ''
			};
		},
		mounted() {
			this.$watch(
				'submittedAnswer',
				function (s) {
					var scoreClasses = '';
					if (s) {
						if (s.student && s.student.submitted) {
							scoreClasses += ' -submitted';
						}
						if (s.answered) {
							scoreClasses += ' show-answer';
						}
					}

					this.scoreClasses = scoreClasses;
				},
				{
					deep: true,
					immediate: true
				}
			);
		},
		directives: {
			'highlighted-answer': function (el, { value }) {
				var sentence = value.sentence;
				var word = value.word;
				var className = value.className;
				if (!sentence || !word) {
					$(el).html('');
				}

				var idx = sentence.toLowerCase().indexOf(word.toLowerCase());
				if (idx === -1) {
					$(el).html(sentence);
				} else {
					word = sentence.substring(idx, idx + word.length);
					var before = sentence.substring(0, idx);
					var after = sentence.substring(idx + word.length, sentence.length);
					$(el).html(before + '<span class="' + className + '">' + word + '</span>' + after);
				}
			}
		},
		methods: {
			navigateToStudentGrading: function (question, subQuestion) {
				if (!this.submittedAnswer) {
					return;
				}
				if (
					subQuestion &&
					this.submittedAnswer.subQuestions &&
					this.submittedAnswer.subQuestions[subQuestion.qid] &&
					this.submittedAnswer.subQuestions[subQuestion.qid].navigateToStudentGrading
				) {
					this.submittedAnswer.subQuestions[subQuestion.qid].navigateToStudentGrading();
				} else if (this.submittedAnswer.navigateToStudentGrading) {
					this.submittedAnswer.navigateToStudentGrading();
				}
			},
			getTextFromHTML: function (html) {
				// Wrap in <span> to allow for special characters in text
				let text = $('<span>' + html + '</span>').text();
				if (text) {
					return text;
				}
				return html;
			},
			getEventData: function (answerId) {
				let qsid = this.qsid;
				let qid = this.q.qid;

				return {
					qsid,
					qid,
					answerId
				};
			},
			hackImageMarkup(s) {
				return s.replace('image-l', '').replace('image-r', '');
			},
			assetUrl(url) {
				return assetUrl(url);
			}
		},
		computed: {
			writtenAnswerLinesImage: function () {
				var grades = this.product.getGrades(),
					isKOr1 = grades && (grades.indexOf(16) !== -1 || grades.indexOf(17) !== -1);

				return isKOr1 ? 'written-answer-lines-b.jpg' : 'written-answer-lines-a.jpg';
			}
		}
	};
</script>
<template>
	<div>
		<template v-if="q.type === TYPE_MULTIPLE_CHOICE || q.type === TYPE_VOCAB_MULTIPLE_CHOICE">
			<div :class="['question', scoreClasses]">
				<div class="question-number">
					<span class="index">{{ index }}.</span>
				</div>
				<div class="question-body">
					<question-text
						:content="q.question"
						:show-tts="showTts"
						:event-data="getEventData()">
					</question-text>
				</div>
			</div>
			<div class="answer">
				<ol>
					<li
						v-for="answer in q.answers"
						:key="answer.answerId"
						v-bind:class="{
							correct: answer.correct,
							chosen: submittedAnswer && submittedAnswer.answerId == answer.answerId,
							incorrect: submittedAnswer && submittedAnswer.answerId == answer.answerId && !answer.correct
						}">
						<span v-html="answer.answer"></span>
						<text-to-speech-player-simple
							v-if="showTts"
							:text="getTextFromHTML(answer.answer)"
							:event-data="getEventData(answer.answerId)">
						</text-to-speech-player-simple>
					</li>
					<li
						v-if="submittedAnswer && !submittedAnswer.answered"
						class="chosen incorrect not-answered">
						Not answered
					</li>
				</ol>
			</div>
		</template>
		<template v-if="q.type === TYPE_WRITTEN_ANSWER">
			<h3 :class="['question', scoreClasses]">
				<div class="question-number">
					<span class="index">{{ index }}.</span>
				</div>
				<div class="question-body">
					<question-text
						:content="q.question"
						:show-tts="showTts"
						:event-data="getEventData()">
					</question-text>
				</div>
			</h3>
			<div class="answer">
				<div
					class="written-answer-lines"
					v-if="product">
					<img :src="assetUrl('/assets/dist/images/' + writtenAnswerLinesImage)" />
					<img :src="assetUrl('/assets/dist/images/' + writtenAnswerLinesImage)" />
					<img
						v-if="writtenAnswerLinesImage === 'written-answer-lines-a.jpg'"
						:src="assetUrl('/assets/dist/images/' + writtenAnswerLinesImage)" />
				</div>
				<p
					v-if="!q.answers || !q.answers.length"
					class="written-answer-sample print-only">
					Answers will vary.
				</p>
				<p class="written-answer-placeholder print-hidden">(written answer)</p>
				<template v-if="!submittedAnswer && q.previewView && q.showAnswer">
					<div
						class="written-answer-real excerpt"
						v-if="q.answers"
						v-html="q.answers[0].answer"></div>
				</template>
				<template v-if="submittedAnswer">
					<div class="written-answer-real">
						<strong class="correct">Answer:</strong>
						<span
							v-if="q.answers"
							v-html="q.answers[0].answer"></span>
						<div
							class="written-answer-submitted"
							v-on:click="navigateToStudentGrading(q)"
							v-bind:class="{
								'-grade-0': submittedAnswer.score === 0,
								'-grade-25': submittedAnswer.score === 25,
								'-grade-50': submittedAnswer.score === 50,
								'-grade-75': submittedAnswer.score === 75,
								'-grade-100': submittedAnswer.score === 100
							}">
							<strong>{{ submittedAnswer.student.firstName || submittedAnswer.student.lastName || 'Student' }}:</strong>
							<template v-if="submittedAnswer.answerText">
								{{ submittedAnswer.answerText }}
							</template>
							<template v-if="submittedAnswer.student.submitted && !submittedAnswer.answerText">
								<span class="question-unanswered">Not answered</span>
							</template>
						</div>
						<button
							v-if="typeof submittedAnswer.score !== 'number' && submittedAnswer.student.submitted"
							v-on:click="navigateToStudentGrading(q)"
							class="-grade-needs-grading margin-top-medium button -outline">
							Grade Answer
						</button>
					</div>
				</template>
			</div>
		</template>
		<template v-if="q.type === TYPE_CLICK_TOUCH_WORD">
			<h3
				:class="['question', scoreClasses]"
				v-html="q.directionStudent"></h3>
			<div class="answer">
				<blockquote
					class="excerpt"
					v-for="(exc, excIndex) in q.excerpts"
					:key="exc">
					<p
						v-highlighted-answer:className="correct"
						v-highlighted-answer:word="q.answers[excIndex].answer"
						v-highlighted-answer:sentence="exc">
						(contents replaced)
					</p>
				</blockquote>
			</div>
		</template>
		<template v-if="q.type === TYPE_WHO_WHAT">
			<div
				:class="['question', scoreClasses]"
				v-html="q.directionStudent"></div>
			<div class="answer">
				<blockquote
					class="excerpt"
					v-for="exc in q.excerpts"
					:key="exc"
					v-html="exc"></blockquote>
			</div>
			<div class="sub-question">
				<div class="answer">
					<ol>
						<li
							v-for="(sq, sqIndex) in q.subQuestions"
							:key="sq.question">
							<span v-html="sq.question"></span>
							<div
								v-if="!q.previewView || q.showAnswer"
								class="written-answer-real">
								<strong class="correct">Answer:</strong>
								<span
									v-if="sq.answers"
									v-html="sq.answers[0].answer"></span>
							</div>
							<div
								v-if="submittedAnswer && sqIndex > 0"
								v-on:click="navigateToStudentGrading(q, sq)"
								class="written-answer-submitted"
								v-bind:class="{
									'-grade-0': submittedAnswer.subQuestions[sq.qid].score === 0,
									'-grade-25': submittedAnswer.subQuestions[sq.qid].score === 25,
									'-grade-50': submittedAnswer.subQuestions[sq.qid].score === 50,
									'-grade-75': submittedAnswer.subQuestions[sq.qid].score === 75,
									'-grade-100': submittedAnswer.subQuestions[sq.qid].score === 100
								}">
								<strong>{{ submittedAnswer.student.firstName || submittedAnswer.student.lastName || 'Student' }}:</strong>
								<template v-if="submittedAnswer.subQuestions[sq.qid] && submittedAnswer.subQuestions[sq.qid].answerText">
									{{ submittedAnswer.subQuestions[sq.qid].answerText }}
								</template>
								<template
									v-if="submittedAnswer.student.submitted && (!submittedAnswer.subQuestions[sq.qid] || !submittedAnswer.subQuestions[sq.qid].answerText)">
									<span class="no-answer">not answered</span>
								</template>
							</div>
							<button
								v-if="submittedAnswer && typeof submittedAnswer.score !== 'number' && submittedAnswer.student.submitted"
								v-on:click="navigateToStudentGrading(q, sq)"
								class="-grade-needs-grading margin-top-medium button -reverse">
								Grade Answer
							</button>
						</li>
					</ol>
				</div>
			</div>
		</template>
		<template v-if="q.type === TYPE_EXTERNAL_ACTIVITY || q.type === TYPE_SPOKEN">
			<h3 :class="['question', scoreClasses]">
				<div class="question-number">
					<span class="index">{{ index }}.</span>
				</div>
				<div class="question-body">
					<question-text
						:content="q.question"
						:show-tts="showTts"
						:event-data="getEventData()">
					</question-text>
				</div>
			</h3>
			<div class="answer">
				<p
					class="external-answer-placeholder"
					v-if="q.type === TYPE_EXTERNAL_ACTIVITY">
					(drawing should be done outside of the website)
				</p>
				<p
					class="external-answer-placeholder"
					v-if="q.type === TYPE_SPOKEN">
					(students should answer out loud)
				</p>
				<template v-if="!submittedAnswer && q.previewView && q.showAnswer">
					<div
						class="external-answer-real excerpt"
						v-html="q.answers[0].answer"></div>
				</template>
				<div v-if="submittedAnswer">
					<div class="written-answer-real">
						<strong class="correct">Answer:</strong>
						<span v-html="q.answers[0].answer"></span>
					</div>
					<div
						class="written-answer-submitted"
						v-bind:class="{
							'-grade-0': submittedAnswer.score === 0,
							'-grade-25': submittedAnswer.score === 25,
							'-grade-50': submittedAnswer.score === 50,
							'-grade-75': submittedAnswer.score === 75,
							'-grade-100': submittedAnswer.score === 100
						}">
						<strong>{{ submittedAnswer.student.firstName || submittedAnswer.student.lastName || 'Student' }}:</strong> (drawing should be done outside of
						the website)
					</div>
				</div>
				<button
					v-on:click="navigateToStudentGrading(q)"
					v-if="submittedAnswer && typeof submittedAnswer.score !== 'number' && submittedAnswer.student.submitted"
					class="-grade-needs-grading margin-top-medium button -outline">
					Grade Answer
				</button>
			</div>
		</template>
		<template v-if="q.type === TYPE_IMAGE_ANSWER">
			<h3 :class="['question', scoreClasses, 'image-answer-question']">
				<div class="question-number">
					<span class="index">{{ index }}.</span>
				</div>
				<div class="question-body">
					<question-text
						:content="q.question"
						:show-tts="showTts"
						:event-data="getEventData()">
					</question-text>
				</div>
			</h3>
			<div class="answer image-answer-answer">
				<div class="grid">
					<div
						class="grid-col-6"
						v-bind:class="{
							correct: a.correct,
							incorrect: !a.correct,
							chosen: submittedAnswer && submittedAnswer.answerId == a.answerId
						}"
						v-for="a in q.answers"
						:key="a.answer">
						<input
							type="radio"
							disabled />
						<label
							v-if="!a.images"
							style="cursor: default"
							v-html="hackImageMarkup(a.answer)"></label>
						<label
							v-if="a.images"
							style="cursor: default">
							<figure>
								<img
									v-for="i in a.images"
									:key="i"
									:src="i"
									:alt="a.caption" />
								<figcaption>
									{{ a.caption }}
									<text-to-speech-player-simple
										v-if="showTts && a.caption"
										:text="getTextFromHTML(a.caption)"
										:event-data="getEventData(a.answerId)">
									</text-to-speech-player-simple>
								</figcaption>
								<img
									v-if="a.correct"
									class="image-answer-correct-check"
									:src="assetUrl('/assets/dist/images/check.jpg')" />
							</figure>
						</label>
					</div>
					<template v-if="submittedAnswer && !submittedAnswer.answered">
						<label class="incorrect not-answered">Not answered</label>
					</template>
				</div>
			</div>
		</template>
	</div>
</template>
<style lang="sass" scoped>
	.index {
		font-weight: bold;
		margin-right: 5px;
	}

	.written-answer-lines {

		display: none;

		img {
			margin-bottom: 1rem;
			max-width: none;
		}
	}

	.image-answer-correct-check {
		display: none;
		font-size: 3rem;
		position: absolute;
		float: none;
		top: 5px;
		margin: 0 auto !important;
		width: 35px;
		left: 0;
		right: 0;
	}
</style>
